import { Button, Input } from '@utima/ui';
import { CircleX } from 'lucide-react';
import { memo, useState } from 'react';

export interface ListInputRowProps {
  /**
   * Name of the input
   */
  name: string;
  /**
   * Type of the input lines (only text is supported for now)
   */
  type: 'text';
  /**
   * Callback for value removed in the input.
   */
  onRemove: (name: string) => void;
  /**
   * Callback for value changes in the input.
   */
  onChange?: (value: string) => void;
  /**
   * If true, the remove button will be disabled.
   */
  disableRemove?: boolean;
  /**
   * Initial value of the input
   */
  initialValue?: string;
  /**
   * Title for the remove button
   */
  removeButtonTitle?: string;
}

export const ListInputRow = memo(function ListInputRow({
  name,
  type,
  onChange,
  onRemove,
  disableRemove,
  initialValue,
  removeButtonTitle,
}: ListInputRowProps) {
  const [value, setValue] = useState<string | number>(initialValue || '');

  return (
    <div className='flex flex-row items-center justify-center gap-2'>
      <Input
        name={name}
        type={type}
        value={value}
        onChange={({ currentTarget }) => {
          setValue(currentTarget.value);
          onChange?.(currentTarget.value);
        }}
      />
      <Button
        variant='ghost'
        outline
        size='icon-sm'
        data-cta='admin-list-input-remove-item-button'
        className='shrink-0'
        type='button'
        title={removeButtonTitle}
        disabled={disableRemove}
        onClick={() => onRemove(name)}
      >
        <CircleX
          className={`size-5 ${disableRemove ? 'text-gray-500' : 'text-red-500'}`}
        />
      </Button>
    </div>
  );
});
